/* global importName */
import store from '@/services/store'
import { getDeepProperty } from '@/helpers/deepObject.js'

const AccountLayout = () => importName('@/scenes/Account/components/AccountLayout.vue', 'accountLayout')
const CreatePrivateApp = () => importName('@/scenes/Account/scenes/PrivateApps/CreatePrivateApp.vue', 'accountCreatePrivateApp')
const PrivateApps = () => importName('@/scenes/Account/scenes/PrivateApps/PrivateApps.vue', 'accountPrivateApps')

const appRoutes = [
  {
    path: 'apps',
    component: AccountLayout,
    children: [
      // /account/:accountId/apps
      {
        path: '/',
        name: 'accounts-private-apps',
        component: PrivateApps,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'accounts-settings' },
            { title: 'Private Apps' }
          ]
        }
      },
      // /account/:accountId/apps/create
      {
        path: 'create',
        name: 'accounts-private-apps-create',
        component: CreatePrivateApp,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'accounts-settings' },
            { title: 'Private Apps', to: 'accounts-private-apps' },
            { title: 'Create' }
          ]
        }
      },
      // /account/:accountId/apps/:appId/edit
      {
        path: ':appId/edit',
        name: 'accounts-private-apps-edit',
        component: CreatePrivateApp,
        props: true,
        meta: {
          breadcrumbs: [
            { title: 'Settings', to: 'accounts-settings' },
            { title: 'Private Apps', to: 'accounts-private-apps' },
            { title: 'Edit' }
          ]
        }
      }
    ],
    beforeEnter: async (to, from, next) => {
      let currentAccount = store.getters.currentAccount
      let defaultAccount = store.getters.defaultAccount
      const canEditClient = getDeepProperty(currentAccount, 'permission.can_edit_client')
      if (!canEditClient) {
        next({
          name: 'accounts-private-apps',
          params: {
            accountId: defaultAccount.id
          }
        })
        return
      }
      next()
    }
  }
]

export default appRoutes
